
import React from "react";
import CategoryCard from "./_UI/CategoryCard";
import { categorys } from "../../lib/categorys";
export const metadata = {
  title: "Categories - Hazrat Ali Problem Solving Website",
  description: "Categories of Hazrat Ali Problem Solving Website",
};
const SubCategories = () =>
{
  // const categorysnames = categorys[14].subcategories.map((category) => category.name);
  return (
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:px-0 px-4 lg:py-20 py-10">
      {categorys[14].subcategories.map((category) => (
        <CategoryCard key={category.id} category={category} />
      ))}
    </div>
  );
};

export default SubCategories;
